"use client";

import styled from "styled-components";
import { textColorSecondary } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyLegend = styled(Text4).withConfig({
  componentId: "sc-1ysb13t-0"
})(["border:none;padding:0;color:", ";"], textColorSecondary);

/**
 * The `Legend` represents a caption for the content of its parent `FieldSet` component.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Content to render inside the Legend Component
 * @returns {React.ReactElement} The Legend component.
 */
const Legend = ({
  children,
  ...props
}) => /*#__PURE__*/_jsx(InternalUseOnlyLegend, {
  renderAs: "legend",
  ...props,
  children: children
});
Legend.displayName = "Legend";
export default Legend;